import React from 'react'
import ReactGA from 'react-ga'

import { Link } from 'react-router-dom'
import DocumentTitle from 'react-document-title'

// import { Spin, Alert } from 'antd'

import ajax from '../components/ControlPanel/utils/ajax'
import globalConfig from '../components/ControlPanel/config'
import CBlock from './block'

import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import Styles from '../styles/Styles'

import classNames from 'classnames'

import '../styles/Quill.scss'


class CommonPage extends React.Component {
    constructor(props) {
        super(props)
        let {
            uri, title, withBorder, beforeAll, beforeBlocks,
        } = props
        withBorder = withBorder || false
        this.state = {
            beforeAll,
            beforeBlocks,
            summary: {},
            blocks: [],
            loading: true,
            uri,
            title,
            withBorder,
        }
    }

    async componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search)
        let { match, beforeAll, beforeAllFunc } = this.props

        const summary = await ajax.get(`${globalConfig.getAPIPath()}/page/summary/${this.state.uri}`)

        if (beforeAllFunc) {
            beforeAll = beforeAllFunc(summary.data, null)
        }

        this.setState({
            beforeAll,
            summary: summary.data,
        })


        // console.log("data:", summary)
        const data = await ajax.get(`${globalConfig.getAPIPath()}/post-block/select`, {
            params: {
                id: summary.data.id,
            },
        })
        // console.log("details,", data)
        // data.data.map((item, id) => {
        //     console.log(item.id)
        // })

        if (beforeAllFunc) {
            beforeAll = beforeAllFunc(summary.data, data.data)
        }

        this.setState({
            beforeAll,
            summary: summary.data,
            blocks: data.data,
            loading: false,
        })
    }

    // renderBlock(block, i) {
    //     const { classes, overrideBlockRender } = this.props
    //     if (overrideBlockRender) {
    //         return overrideBlockRender(block, i)
    //     } else {
    //         const { title, authors, text } = block
    //         let authorsElems = null
    //         if (authors && authors.length > 0) {
    //             authorsElems = (<div className="TextShadow">
    //                 <strong>Authors:</strong>
    //                 <ul style={{ paddingLeft: '5%' }}>{[...authors.map((a, i) => <li key={i}>{a || ''}</li>)]}</ul>
    //             </div>)
    //         }
    //         const name = this.state.withBorder ? 'Section' : ''
    //         // return (<div className={name} key={i} style={{ paddingBottom: '10px' }}>
    //         //     <h2 className="TextGold">{title || ""}</h2>
    //         //     <hr />
    //         //     {authorsElems}
    //         //     <div dangerouslySetInnerHTML={{ __html: text }} />
    //         // </div>)
    //         return (<div key={i} style={{ paddingBottom: '10px' }}>
    //             <Card className={classes.card}>
    //                 <CardContent>
    //                     <Typography variant="headline" component="h2">
    //                         {title || ''}
    //                     </Typography>
    //                     {authorsElems}
    //                 </CardContent>
    //                 <CardContent>
    //                     <Typography component="p">
    //                         <span dangerouslySetInnerHTML={{ __html: text }} style={{ display: 'inline' }} />
    //                     </Typography>
    //                 </CardContent>
    //             </Card>
    //         </div>)
    //     }
    // }

    render() {
        const { classes } = this.props
        let { title, summary, text } = this.state.summary
        const docTitle = `SunLab :: ${this.state.title || title || 'Page'}`

        return (<div className="Quill">
            <DocumentTitle title={docTitle} />

            {/* <div style={{ paddingBottom: '10px' }}>
                <Card className={classes.card}>
                    <CardContent>
                      <Typography component="div">
                          {this.state.beforeAll}
                          <div dangerouslySetInnerHTML={{ __html: text }} style={{ 'display': 'inline' }} />
                      </Typography>
                    </CardContent>
                  </Card>
            </div> */}

            <div style={{ paddingBottom: '10px' }}>
                <CardContent>
                    <Typography variant="headline" component="h1">
                        {title || ''}
                    </Typography>
                </CardContent>

                <Typography component="div" >
                    {this.state.beforeAll}
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </Typography>
            </div>

            <div className="clearfix" />
            {this.state.beforeBlocks}
            <div className="clearfix" />
            {/* {[...this.state.blocks.map((b, i) => this.renderBlock(b, i))]} */}
            {[...this.state.blocks.map((b, i) => <CBlock block={b} id={i} />)]}
            {
                this.state.loading
                    ? <div className="Center"><CircularProgress className={classes.progress} size={80} /></div>
                    : null
            }
        </div>)
    }
}

CommonPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(Styles)(CommonPage)
